<template>
  <div class="component" id="ContentBox" ref="ContentBox">
    <div class="notice-box">
      <div
        class="pre-box"
        v-html="it.content"
        :key="'ContentBox@' + index"
        v-for="(it, index) in arr"
        :style="{ color: it.color }"
      ></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Image, ImagePreview } from "vant";
Vue.use(Image).use(ImagePreview);
export default {
  name: "ContentBox",
  filters: {},
  props: {
    arr: Array,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    // let that = this;
  },
  methods: {},
};
</script>

<style scoped lang="less">
@import "../main";
#ContentBox.component {
  .notice-box {
    box-sizing: border-box;
    width: 100%;
    padding: 8px 19px 8px;
    .pre-box {
      box-sizing: border-box;
      width: 100%;
      text-align: justify;
      color: rgb(85, 85, 85);
      font-size: 13px;
      line-height: 19.5px;
      overflow: hidden;
      display: block;
      text-align: justify;
      white-space: pre-wrap;
    }
  }
}
</style>
